type ClientListParams = {
  clientType?: string[] | null;
  descending?: boolean;
  orderBy?: string;
  page?: number;
  pageSize?: number;
  paymentType?: string[] | null;
  search?: string;
  tenantId?: string | null;
};

export const clientQueryKeys = {
  all: ["clients"] as const,
  lists: () => [...clientQueryKeys.all, "list"] as const,
  list: (params: ClientListParams) =>
    [
      ...clientQueryKeys.all,
      params.clientType,
      params.descending,
      params.orderBy,
      params.page,
      params.pageSize,
      params.paymentType,
      params.search,
      params.tenantId,
    ] as const,
  details: () => [...clientQueryKeys.all, "detail"] as const,
  detail: (clientId: string) =>
    [...clientQueryKeys.details(), clientId] as const,
  filters: () => [...clientQueryKeys.all, "filters"] as const,
  filter: (tenantId?: string | null, search?: string) =>
    [...clientQueryKeys.filters(), tenantId, search] as const,
};
